import { createGlobalStyle } from 'styled-components';

//@dev we not adding font in body since we building our widget in a div
const GlobalStyle = createGlobalStyle`
  body {
    font-family: 'Rubik', sans-serif;
    margin: 0px !important;
  }
`;

export default GlobalStyle;
